import { render } from "./TestimonialBox.vue?vue&type=template&id=60ef6b20"
import script from "./TestimonialBox.vue?vue&type=script&lang=js"
export * from "./TestimonialBox.vue?vue&type=script&lang=js"

import "./TestimonialBox.vue?vue&type=style&index=0&id=60ef6b20&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__